import React, { useCallback, useEffect, useState } from 'react';
// import styled from 'styled-components'
import "./input-searchAutocomplete.scss";
import _ from "lodash";

interface ISuggestion {
    mainText: string;
    secondaryText: string;
    value: any;
    onClick(suggestion: any);
}

interface IProps {
    value?: string;
    suggestions?: ISuggestion[];
    placeholder?: string;
    debounce?: number;
    onSearch(query: string): any;
}

const InputSearch = ({ value = '', suggestions, placeholder = '', debounce = 700, onSearch }: IProps) => {

    const [valueAux, setValue] = useState<string>();
    const [suggestionsAux, setSuggestionsAux] = useState<ISuggestion[]>([]);
    // const delayedQuery = useCallback(_.debounce(query => search(query), debounce), []); 
    // TO-DO DELAY ESTA QUEBRANDO O CONTEXTO 

    useEffect(() => {
        if (value) {
            setValue(value);
        }
    }, [value]);

    useEffect(() => {
        if (suggestions) {
            setSuggestionsAux(suggestions);
        }

    }, [suggestions]);

    const search = (query: string) => {
        onSearch(query);
    }

    const handleSearch = (query: string) => {
        setValue(query);
        search(query);
        // delayedQuery(query);
    }

    const renderSuggestions = () => {
        return suggestionsAux.map(({ mainText, secondaryText, value, onClick }: ISuggestion, index) => {
            return (
                <li key={index} onClick={onClick(value)}>
                    <strong>{mainText}</strong> <small>{secondaryText}</small>
                </li>
            );
        });
    };

    return (
        <div className="input-search-autocomplete-content">
            <input
                type="text"
                placeholder={placeholder}
                className="input-search-autocomplete-box"
                value={valueAux || ""}
                onChange={({ target }) => handleSearch(target.value)}
            />

            <div className="input-search-autocomplete-icon-container">
                {/* <i className="fas fa-search fa-flip-horizontal"></i> */}
                <i className="fas fa-search"></i>
            </div>

            {valueAux &&
                <div className="input-search-autocomplete-clear-container">
                    {/* <i className="fas fa-search fa-flip-horizontal"></i> */}
                    <i className="fas fa-times" onClick={()=>handleSearch("")}></i>
                </div>

            }

            {suggestionsAux.length > 0 && <ul>{renderSuggestions()}</ul>}
        </div>
    );
}

export default React.memo(InputSearch);



